import {Agency} from "../../entities/Agency.ts";
import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";

export class GetTourOperatorAgenciesUseCase{

    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(): Promise<Agency[]> {
        return this.agencyRepository.getAgenciesByTourOperatorId();
    }
}
